/* 手机号验证 */
export const mobileValidate = (value: string) => {
    const regExp = /^1\d{10}$/;
    return regExp.test(value);
}